import constants from "../utils/constants";
import { publicRequest } from "../utils/axsiosInstances";

class AccountController {
  static sendOtp(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "register",
      data: {
        mobile: data.mobile,
      },
    });
  }

  static sendOtpV2(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV2 + "register",
      data: {
        mobile: data.mobile,
      },
    });
  }

  static resendOTP(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "resend",
      data: {
        mobile: data.mobile,
      },
    });
  }

  static register(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "confirm",
      data: {
        mobile: data.mobile,
        otp: data.otp,
      },
    });
  }

  static login(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "login",
      data: {
        mobile: data.mobile,
        password: data.password,
        deviceId:
          "eyJzeXN0ZW1fbmFtZSI6IkFuZHJvaWQiLCJzeXN0ZW1fdmVyc2lvbiI6IjExIiwibW9kZWwiOiJBbmRyb2lkIFNESyBidWlsdCBmb3IgeDg2IiwibWFudWZhY3R1cmVyIjoidW5rbm93biIsImRldmljZSI6ImdlbmVyaWNfeDg2IiwiYW5kcm9pZF9pZCI6ImY1Y2NkMzBmYTk4YWY2MzYifQ==",
      },
    });
  }

  static setPassword(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "set-password",
      data: {
        mobile: data.mobile,
        password: data.password,
      },
    });
  }

  static sendForgotPasswordOTP(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "forgot-password/init",
      data: {
        mobile: data.mobile,
      },
    });
  }

  static confirmForgotPasswordOTP(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "forgot-password/confirm",
      data: {
        mobile: data.mobile,
        otp: data.otp,
      },
    });
  }

  static finishForgotPassword(data) {
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "forgot-password/finish",
      data: {
        mobile: data.mobile,
        list: data.list,
      },
    });
  }
}

export default AccountController;
